import { stats } from "./StatFlipCards";

/** "By the numbers" beside Our Purpose, in the site's plain editorial style (no cards):
 *  the big red Total Builders figure, then the three supporting numbers in a row.
 *  Steve, Oct 25: "put the numbers next to Our Purpose" and no cards. */
const StatList = () => {
  const [big, ...rest] = stats;
  return (
    <div className="w-full">
      <div className="border-y-2 border-primary/80 py-6 md:py-8">
        <span className="font-heading block text-6xl leading-none text-primary sm:text-7xl md:text-8xl">
          {big.value}
        </span>
        <span className="btn-caps mt-2 block text-xs tracking-[0.18em] text-foreground md:text-sm">
          {big.label}
        </span>
      </div>
      <div className="grid grid-cols-3 divide-x divide-hxp-sand-dark border-b border-hxp-sand-dark">
        {rest.map((s) => (
          <div key={s.label} className="py-5 pl-4 first:pl-0 md:py-6">
            <span className="font-heading text-4xl text-foreground md:text-5xl">{s.value}</span>
            <div className="mt-2 flex items-center gap-2">
              <span className="h-1 w-6 bg-primary" />
              <span className="btn-caps text-[10px] tracking-[0.14em] text-foreground/60 md:text-[11px]">
                {s.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatList;
